// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"333":"epub","962":"home"}[chunkId] || chunkId) + "." + {"333":"c80b4e57","546":"4c3f8be5","869":"5bb26aa5","962":"ff1ac019"}[chunkId] + ".chunk.js";
};